export default __webpack_public_path__ + "static/media/Bindings of Infernal Zeal.85cc3a5d.jpg";